export default __webpack_public_path__ + "static/media/AKM_2.a4da4969.png";